import { useQuery } from "@tanstack/react-query";

import { getFootprintingDairyManureAdditive } from "services";

import { FOOTPRINTING_DAIRY_MANURE_ADDITIVE } from "consts";

export const useGetFootprintingDairyManureAdditive = (primaryDataId?: string) =>
  useQuery({
    queryKey: [FOOTPRINTING_DAIRY_MANURE_ADDITIVE, primaryDataId],
    queryFn: () => getFootprintingDairyManureAdditive(primaryDataId ?? ""),
    enabled: !!primaryDataId,
    gcTime: 0,
  });
